import { isDevSite, isPreviewSite, isDevOrPreviewSite } from './utils/general'
import {
  imageMimeTypes,
  imageExtensions,
  docMimeTypes,
  docExtensions,
  pptMimeTypes,
  pptExtensions,
  excelMimeTypes,
  excelExtensions,
  videoMimeTypes,
  videoExtensions,
  audioMimeTypes,
  audioExtensionsBrowserNative,
  codeMimeTypes,
  codeExtensions,
  lottieMimeTypes,
  lottieExtensions,
  ebookMimeTypes,
  ebookExtensions,
  latexMimeTypes,
  latexExtensions
} from './helpers/file-type'

export const DOMAIN_SUFFIX = isDevSite() ? '.tiiny.co.uk' : '.tiiny.site'

export const TLDS = {
  TIINY_SITE: '.tiiny.site',
  TIINY_CO: '.tiiny.co',
  TIINY_CO_UK: '.tiiny.co.uk',
  TIINY_IO: '.tiiny.io',
  TIINY_HOST: '.tiiny.host',
  TIINY_PREVIEW_CO_UK: '.preview.tiiny.co.uk'
}

export const DEFAULT_TLDS = Object.values(TLDS)

export const TLD_S3_PATH_CONFIG = {
  [TLDS.TIINY_SITE]: ({ subdomain }) => subdomain,
  [TLDS.TIINY_CO]: ({ subdomain, tld }) => `${subdomain}${tld}`,
  [TLDS.TIINY_CO_UK]: ({ subdomain, tld }) => `${subdomain}${tld}`
}

export const FILE_TYPE = {
  PDF: 'PDF',
  HTML: 'HTML'
}

export const SITE_UPLOAD_TEXT = 'UPLOAD_TEXT'

// Analytics
export const SOURCE_HOMEPAGE = 'SOURCE_HOMEPAGE'
export const SOURCE_LOGIN = 'SOURCE_LOGIN_PAGE'
export const SOURCE_PRICING = 'SOURCE_PRICING_PAGE'
export const SOURCE_LOGGED_IN = 'SOURCE_LOGGED_IN'
export const SOURCE_UNKNOWN = 'SOURCE_UNKNOWN'

// errors
export const errors = {
  DOMAIN_EXISTS: 'DOMAIN_EXISTS',
  NOT_OWNER: 'NOT_OWNER',
  NO_INDEX_FILE: 'NO_INDEX_FILE',
  EXCEEDS_FILE_SIZE: 'EXCEEDS_FILE_SIZE',
  EXCEEDS_SITE_LIMIT: 'EXCEEDS_SITE_LIMIT',
  MALICIOUS_CODE: 'MALICIOUS_CODE',
  ERROR_WITH_FILE: 'ERROR_WITH_FILE',
  SITE_ANALYTICS_DOES_NOT_EXISTS: 'SITE_ANALYTICS_DOES_NOT_EXISTS',
  INVALID_EMAIL: 'INVALID_EMAIL',
  ACCOUNT_NOT_EXISTS: 'ACCOUNT_NOT_EXISTS',
  UNAUTHORIZED: 'UNAUTHORIZED',
  USER_EXISTS: 'USER_EXISTS',
  USER_TRIAL_EXPIRED: 'USER_TRIAL_EXPIRED',
  USER_UNVERIFIED: 'USER_UNVERIFIED',
  NO_CONTENT: 'NO_CONTENT',
  NO_FILE_FOUND: 'NO_FILE_FOUND',
  NO_LINK_FOUND: 'NO_LINK_FOUND',
  TOKEN_INVALID: 'TOKEN_INVALID',
  NO_PARENT_ACCOUNT: 'NO_PARENT_ACCOUNT',
  PASSWORD_ERROR: 'PASSWORD_ERROR',
  WAITING: 'WAITING',
  SSL_ERROR: 'SSL_ERROR',
  DNS_CONFIG_ERROR: 'DNS_CONFIG_ERROR',
  NO_CUSTOMER_ID: 'NO_CUSTOMER_ID',
  NO_SUBDOMAIN: 'NO_SUBDOMAIN',
  WASMER_DEPLOY_ERROR: 'WASMER_DEPLOY_ERROR',
  WASMER_DELETE_ERROR: 'WASMER_DELETE_ERROR',
  IP_BLOCK_ERROR: 'IP_BLOCK_ERROR',
  BANNED_SITE: 'BANNED_SITE',
  INVALID_AUTH_TOKEN: 'INVALID_AUTH_TOKEN',
  STRIPE_SUBSCRIPTION_CHECK_ERROR: 'STRIPE_SUBSCRIPTION_CHECK_ERROR',
  STRIPE_EMAIL_CHECK_ERROR: 'STRIPE_EMAIL_CHECK_ERROR',
  PADDLE_SUBSCRIPTION_CHECK_ERROR: 'PADDLE_SUBSCRIPTION_CHECK_ERROR',
  PADDLE_EMAIL_CHECK_ERROR: 'PADDLE_EMAIL_CHECK_ERROR',
  S3_ERROR: 'S3_ERROR',
  DYNAMO_QUERY_ERROR: 'DYNAMO_QUERY_ERROR',
  DYNAMO_NO_CONTENT: 'DYNAMO_NO_CONTENT',
  INVALID_UPDATE_CODE: 'INVALID_UPDATE_CODE',
  BAD_CAPTCHA: 'BAD_CAPTCHA',
  NO_CAPTCHA: 'NO_CAPTCHA',
  BAD_WEBHOOK_KEY: 'BAD_WEBHOOK_KEY',
  FORBIDDEN: 'FORBIDDEN',
  DOMAIN_DOES_NOT_EXIST: 'DOMAIN_DOES_NOT_EXIST',
  DOMAIN_IS_NOT_PROTECTED: 'DOMAIN_IS_NOT_PROTECTED',
  INVALID_DOMAIN: 'INVALID_DOMAIN',
  EMAIL_REQUIRED: 'EMAIL_REQUIRED',
  NO_ACTIVE_SUBSCRIPTION: 'NO_ACTIVE_SUBSCRIPTION',
  EMAIL_ALREADY_SUBSCRIBED: 'EMAIL_ALREADY_SUBSCRIBED',
  FAILED_TO_SUBSCRIBE_EMAIL: 'FAILED_TO_SUBSCRIBE_EMAIL',
  INVALID_ZIP_FILE: 'INVALID_ZIP_FILE',
  PLAN_NOT_FOUND: 'PLAN_NOT_FOUND',
  UPGRADE_PLAN_ERROR: 'UPGRADE_PLAN_ERROR',
  INVALID_COUPON: 'INVALID_COUPON',
  FAILED_TO_CONVERT_IMAGE_TO_PNG: 'FAILED_TO_CONVERT_IMAGE_TO_PNG',
  FAILED_TO_CONVERT_FILE_TO_HTML: 'FAILED_TO_CONVERT_FILE_TO_HTML',
  FAILED_TO_CONVERT_FILE_TO_PDF: 'FAILED_TO_CONVERT_FILE_TO_PDF',
  S3_UPLOAD_ERROR: 'S3_UPLOAD_ERROR',
  UNSUPPORTED_FILE_TYPE: 'UNSUPPORTED_FILE_TYPE',
  SIGNUP_RECORD_NOT_FOUND: 'SIGNUP_RECORD_NOT_FOUND',
  DNS_CHECK_ERROR: 'DNS_CHECK_ERROR',
  ACM_ERROR: 'ACM_ERROR',
  CLOUDFRONT_ERROR: 'CLOUDFRONT_ERROR',
  ACM_STATUS_FAILED: 'ACM_STATUS_FAILED',
  ACM_STATUS_EXPIRED: 'ACM_STATUS_EXPIRED',
  ACM_CERT_STATUS_FAILED: 'ACM_CERT_STATUS_FAILED',
  TRACKED_LINKS_LABEL_EXISTS: 'TRACKED_LINKS_LABEL_EXISTS',
  TRACKED_LINKS_NOT_FOUND: 'TRACKED_LINKS_NOT_FOUND',
  TRACKED_LINKS_LIMIT_REACHED: 'TRACKED_LINKS_LIMIT_REACHED',
  TRACKED_LINKS_INVALID_INPUT: 'TRACKED_LINKS_INVALID_INPUT',
  TRACKED_LINKS_REF_MISSING: 'TRACKED_LINKS_REF_MISSING',
  TRACKED_LINKS_PLAUSIBLE_ERROR: 'TRACKED_LINKS_PLAUSIBLE_ERROR',
  INVALID_UPLOADER_EMAIL: 'INVALID_UPLOADER_EMAIL',
  INVALID_TRANSFER_REQUEST_LINK: 'INVALID_TRANSFER_REQUEST_LINK',
  EXCEEDS_ACCOUNT_LIMIT: 'EXCEEDS_ACCOUNT_LIMIT',
  EXCEEDS_ACCOUNT_LIMIT_TRANSFER_REQUEST: 'EXCEEDS_ACCOUNT_LIMIT_TRANSFER_REQUEST',
  SSO_UNAVAILABLE: 'SSO_UNAVAILABLE',
  SSO_FAIL: 'SSO_FAIL',
  SSO_EMAIL_REQUIRED: 'SSO_EMAIL_REQUIRED'
}

export const messages = {
  CUSTOM_DOMAIN: {
    CLOUDFRONT_STATUS_IN_PROGRESS: 'CLOUDFRONT_STATUS_IN_PROGRESS',
    ACM_STATUS_PENDING_VALIDATION: 'ACM_STATUS_PENDING_VALIDATION'
  }
}

export const ERROR_MSGS = {
  [errors.INVALID_EMAIL]: 'Please enter a genuine email address',
  [errors.INVALID_UPDATE_CODE]: 'Invalid update code',
  [errors.NOT_OWNER]: 'Sorry, that link-name is taken',
  [errors.NO_INDEX_FILE]: "Your zip doesn't contain an index.html file",
  [errors.DOMAIN_EXISTS]: 'Sorry, that link-name is taken',
  [errors.USER_EXISTS]: 'User exists, please login to your account',
  [errors.USER_TRIAL_EXPIRED]: 'Sorry, your trial has expired. Please upgrade.',
  [errors.USER_UNVERIFIED]: "Please verify your account, we've sent you an email",
  [errors.MALICIOUS_CODE]:
    'We\'re unable to host this type of content <br />on a <b>free account</b>.<br/><br/><a href="https://tiiny.host/pricing"><b><u>Upgrade your account</u></b></a>',
  [errors.ERROR_WITH_FILE]: 'Oops! An error occured with the file', // ;)
  [errors.EXCEEDS_FILE_SIZE]: 'The file size exceeds the maximum allowed limit',
  [errors.EXCEEDS_SITE_LIMIT]: 'You have reached the maximum number of sites allowed',
  [errors.SITE_ANALYTICS_DOES_NOT_EXISTS]: 'Site analytics data does not exist',
  [errors.ACCOUNT_NOT_EXISTS]: 'This account does not exist',
  [errors.UNAUTHORIZED]: 'You are not authorized to perform this action',
  [errors.NO_CONTENT]: 'No content found',
  [errors.NO_FILE_FOUND]: 'The requested file was not found',
  [errors.NO_LINK_FOUND]: 'The requested link was not found',
  [errors.TOKEN_INVALID]: 'The provided token is invalid',
  [errors.NO_PARENT_ACCOUNT]: 'No parent account found',
  [errors.PASSWORD_ERROR]: 'Incorrect password',
  [errors.WAITING]: 'Please wait while we process your request',
  [errors.SSL_ERROR]: 'There was an error with the SSL certificate',
  [errors.DNS_CONFIG_ERROR]: 'There was an error with the DNS configuration',
  [errors.NO_CUSTOMER_ID]: 'No customer ID found',
  [errors.NO_SUBDOMAIN]: 'No subdomain specified',
  [errors.WASMER_DEPLOY_ERROR]: 'Error deploying site',
  [errors.WASMER_DELETE_ERROR]: 'Error deleting site',
  [errors.IP_BLOCK_ERROR]: '',
  [errors.BANNED_SITE]: 'Connection error. Unable to access account.',
  [errors.INVALID_AUTH_TOKEN]: 'Invalid authentication token',
  [errors.STRIPE_SUBSCRIPTION_CHECK_ERROR]: 'Error checking Stripe subscription',
  [errors.STRIPE_EMAIL_CHECK_ERROR]: 'Error checking Stripe email',
  [errors.PADDLE_SUBSCRIPTION_CHECK_ERROR]: 'Error checking Paddle subscription',
  [errors.PADDLE_EMAIL_CHECK_ERROR]: 'Error checking Paddle email',
  [errors.S3_ERROR]: 'Error with service',
  [errors.DYNAMO_QUERY_ERROR]: 'Query error',
  [errors.DYNAMO_NO_CONTENT]: 'No content found',
  [errors.BAD_CAPTCHA]: 'Bad captcha, please refresh your page & try again or try a different browser',
  [errors.NO_CAPTCHA]: 'Captcha verification failed, please refresh your page & try again or try a different browser',
  [errors.BAD_WEBHOOK_KEY]: '',
  [errors.FORBIDDEN]: 'Forbidden',
  [errors.DOMAIN_DOES_NOT_EXIST]: 'Domain does not exist',
  [errors.DOMAIN_IS_NOT_PROTECTED]: 'Domain is not protected',
  [errors.INVALID_DOMAIN]: 'Invalid domain',
  [errors.EMAIL_REQUIRED]: 'Email is required',
  [errors.NO_ACTIVE_SUBSCRIPTION]: 'No active subscription found',
  [errors.EMAIL_ALREADY_SUBSCRIBED]: 'Email already subscribed to the list',
  [errors.FAILED_TO_SUBSCRIBE_EMAIL]: 'Failed to subscribe email to the list',
  [errors.INVALID_ZIP_FILE]: 'The zip file is invalid',
  [errors.PLAN_NOT_FOUND]: 'Customer does not have a plan',
  [errors.UPGRADE_PLAN_ERROR]: 'Error upgrading plan',
  [errors.INVALID_COUPON]: 'Provide a valid coupon',
  [errors.FAILED_TO_CONVERT_IMAGE_TO_PNG]: 'Failed to convert file',
  [errors.FAILED_TO_CONVERT_FILE_TO_HTML]: 'Failed to convert file',
  [errors.FAILED_TO_CONVERT_FILE_TO_PDF]: 'Failed to convert file',
  [errors.S3_UPLOAD_ERROR]: 'Error with service',
  [errors.UNSUPPORTED_FILE_TYPE]: 'Unsupported file type',
  [errors.SIGNUP_RECORD_NOT_FOUND]: 'Unable to configure your account, please try logging in again',
  [errors.DNS_CHECK_ERROR]: 'DNS diagnostics failed',
  [errors.ACM_ERROR]: 'DNS diagnostics failed',
  [errors.CLOUDFRONT_ERROR]: 'DNS diagnostics failed',
  [errors.ACM_STATUS_FAILED]: `You may need to add an additional CAA record for successful validation:<br/><br/>
    <pre><code>Type: CAA
    Name: @
    Tag: issuewild
    Flag: 0
    CA Domain: amazon.com</code></pre>`,
  [errors.ACM_STATUS_EXPIRED]: 'Domain configuration has expired. Please delete your domain and add it again',
  [errors.ACM_CERT_STATUS_FAILED]: 'Domain was not configured successfully. Please delete your domain and add it again',

  [errors.TRACKED_LINKS_LABEL_EXISTS]: 'Tracked link label for this site already exists',
  [errors.TRACKED_LINKS_NOT_FOUND]: 'Tracked link not found',
  [errors.TRACKED_LINKS_LIMIT_REACHED]: "You can't add more than 20 tracked links per site",
  [errors.TRACKED_LINKS_INVALID_INPUT]: 'Invalid data provided',
  [errors.TRACKED_LINKS_REF_MISSING]: 'Invalid data provided',
  [errors.TRACKED_LINKS_PLAUSIBLE_ERROR]: "We weren't able to retrieve statistics for this site",
  [errors.INVALID_UPLOADER_EMAIL]: 'Invalid uploader email',
  [errors.INVALID_TRANSFER_REQUEST_LINK]: 'Invalid transfer request link',
  [errors.EXCEEDS_ACCOUNT_LIMIT]: `Please increase the storage limit on your account to upload this file. Contact support for assistance`,
  [errors.EXCEEDS_ACCOUNT_LIMIT_TRANSFER_REQUEST]: `Unable to upload file, larger than account's storage limit. Please contact owner`,
  [errors.SSO_UNAVAILABLE]: 'SSO sign-in failed. Try again or use email login.',
  [errors.SSO_FAIL]: 'SSO sign-in failed. Try again or use email login.',
  [errors.SSO_EMAIL_REQUIRED]: 'Enter your work email to sign in with SSO.'
}

export const MSGS = {
  [messages.CUSTOM_DOMAIN.ACM_STATUS_PENDING_VALIDATION]:
    'Verification still pending - It make take a few more hours to validate, please contact support if it takes longer than 24 hours',
  [messages.CUSTOM_DOMAIN.CLOUDFRONT_STATUS_IN_PROGRESS]:
    'Verification still pending - It make take a few more hours to configure, please contact support if it takes longer than 24 hours'
}

export const MIXED_FOLDER_ERROR_MSG =
  "You can't upload a folder in combination with other files. Please place all your files in the folder and upload again."
export const MIXED_ZIP_ERROR_MSG =
  "You can't upload a zip in combination with other files. Please put all your files into the ZIP file."

export const ignoreAxiosErrors = ['Request aborted', 'Network Error']

// prettier-ignore
export const REGEX_FULLDOMAIN = /^([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;
// prettier-ignore
export const REGEX_SUBDOMAIN = /^(?!-)[A-Za-z0-9-]*[A-Za-z0-9]-?$/
// prettier-ignore
export const REGEX_DOMAIN = /^[A-Za-z0-9](?:[A-Za-z0-9\\-]{0,61}[A-Za-z0-9])*$/;
// prettier-ignore
export const REGEX_EMAIL =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// prettier-ignore
export const REGEX_USERNAME = /^[a-zA-Z0-9_]{3,20}$/;
// prettier-ignore
export const REGEX_PASSWORD = /^[^:]+$/;
// prettier-ignore
export const REGEX_ERROR_PATH = /^\/.+$/;

export const DISALLOWED_EMAILS = ['hi2.in', 'mailinator.com']

export const FREE_EMAIL_DOMAINS = [
  // Major providers
  'GMAIL',
  'GOOGLEMAIL',
  'OUTLOOK',
  'HOTMAIL',
  'YAHOO',
  'YMAIL',
  'ROCKETMAIL',
  'AOL',
  'LIVE',
  'MSN',

  // Apple
  'ICLOUD',
  'ME',
  'MAC',

  // Privacy-focused
  'PROTONMAIL',
  'PROTON',
  'TUTANOTA',
  'TUTAMAIL',

  // International providers
  'YANDEX',
  'MAIL',
  'GMX',
  'WEB',
  'FASTMAIL',
  'ZOHO',

  // Telecom providers
  'VERIZON',
  'COMCAST',
  'XFINITY',
  'ATT',
  'BELLSOUTH',
  'CHARTER',
  'COX',
  'EARTHLINK',
  'ROADRUNNER',
  'SBCGLOBAL',

  // Other common free providers
  'REDIFFMAIL',
  'INBOX',
  'MAIL2WORLD',
  'JUNO',
  'NAVER',
  'DAUM',
  'HANMAIL',
  'QQ',
  '163',
  '126',
  'SINA',
  'SOHU',
  'YEAH',
  'LIBERO',
  'ALICE',
  'TIN',
  'VIRGILIO',
  'UOL',
  'BOL',
  'IG',
  'R7',
  'TERRA',
  'GLOBO',
  'ZIPMAIL',
  'LYCOS',
  'EXCITE'
]

export const MAX_FILE_SIZE = 25
export const MAX_PDF_SIZE = 25
export const MAX_FILE_SIZE_FREE = 75 // allow link preview for free users
export const MAX_REPO_SIZE_MB = 75

export const MAX_FREE_FILE_SIZE = 3
export const MAX_FREE_PDF_SIZE = 0.5

const getFrontendURL = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return window.location.origin
  }

  if (isPreviewSite()) {
    return 'https://preview.tiiny.co.uk'
  }

  if (isDevSite()) {
    return 'https://www.tiiny.co.uk'
  }

  return 'https://tiiny.host'
}

export const FRONTEND_ROOT = getFrontendURL()

const getBaseURL = () => {
  if (process.env.REACT_APP_USE_PROD_BACKEND === 'true') {
    return 'https://api.tiiny.host'
  }

  if (process.env.REACT_APP_USE_PREVIEW_BACKEND === 'true') {
    return 'https://preview-api.tiiny.co.uk'
  }

  if (process.env.REACT_APP_USE_DEV_BACKEND === 'true') {
    return 'https://api.tiiny.co.uk'
  }

  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:8000'
  } else if (isPreviewSite()) {
    return 'https://preview-api.tiiny.co.uk'
  } else if (isDevSite()) {
    return 'https://api.tiiny.co.uk'
  } else {
    return 'https://api.tiiny.host'
  }
}

export const API_ROOT = getBaseURL()

export const DROPBOX_APP_KEY = 'o5qybcv1pc4vkxp'

export const DROPBOX_SCRIPT_SRC = 'https://unpkg.com/dropbox/dist/Dropbox-sdk.min.js'

export const DROPBOX_CHOOSER_SCRIPT_SRC = 'https://www.dropbox.com/static/api/2/dropins.js'

export const reCAPTCHA_CLIENT = '6LeMIfQUAAAAAGblGGmutcrS1gaG3YMyRPzkG5N7'

export const POSTHOG_KEY = 'phc_tOE35vERDZGbbeCZ1dLrMGly1T1iPDT8DFXZV0jpp3Y'
export const POSTHOG_HOST = 'https://ph.tiiny.host'

// Self-hosted Plausible instance - same one the backend talks to via ANALYTICS_BASE_URL
export const PLAUSIBLE_HOST = 'https://analytics.tiiny.site'

export const GAME_CATEGORIES = ['Arcade', 'Adventure', 'Puzzle', 'Action', 'Strategy', 'Racing', 'Sports']

const getStripeKey = () => {
  if (isDevOrPreviewSite()) {
    return 'pk_test_51GyQOLKnX1nnNv6ISZ7YCm5nBySiWLHHcFIir2ALdrrARBkHnSwZe2CTbadw9pWLEBbLVncQOAsXh56RK8YNMRsD00QdWbapEb'
  } else {
    return 'pk_live_51GyQOLKnX1nnNv6I5F3a2LwxUfNq7kDmV4oNDqpXk1LGdgaKaiOelZsUt8I7SYqffFSkBeYkyMNU9kWBAo7vFqtx00Rcdt5Fcu'
  }
}

export const STRIPE_KEY = getStripeKey()

export const ARCHIVE_ENDPOINT = 'https://s3-eu-west-1.amazonaws.com/archive.tiiny.host'

export const ENTRI_APP_ID = isDevSite() ? 'tiiny.host_dev' : 'tiiny.host'

export const DROPZONE_ACCEPTED_FILES =
  'text/html, application/zip, application/x-zip-compressed, multipart/x-zip, application/pdf, .pdf, .php, text/php, ' +
  imageMimeTypes.join(', ') +
  ', ' +
  docMimeTypes.join(', ') +
  ', ' +
  pptMimeTypes.join(', ') +
  ', ' +
  audioMimeTypes.join(', ') +
  ', ' +
  codeMimeTypes.join(', ') +
  ', ' +
  lottieMimeTypes.join(', ') +
  ', ' +
  ebookMimeTypes.join(', ') +
  ', ' +
  latexMimeTypes.join(', ') +
  ', ' +
  excelMimeTypes.join(', ') +
  ', .' +
  imageExtensions.join(', .') +
  ', .' +
  docExtensions.join(', .') +
  ', .' +
  pptExtensions.join(', .') +
  ', .' +
  audioExtensionsBrowserNative.join(', .') +
  ', .' +
  codeExtensions.join(', .') +
  ', .' +
  lottieExtensions.join(', .') +
  ', .' +
  ebookExtensions.join(', .') +
  ', .' +
  latexExtensions.join(', .') +
  ', .' +
  excelExtensions.join(', .')

export const DROPZONE_ACCEPTED_FILES_PRO =
  DROPZONE_ACCEPTED_FILES + ', ' + videoMimeTypes.join(', ') + ', .' + videoExtensions.join(', .')

export const linkPreviewTypes = {
  MALICIOUS_CONTENT: 'MALICIOUS_CONTENT',
  FILE_SIZE: 'FILE_SIZE',
  VIDEO_FILE: 'VIDEO_FILE',
  PROJECT_LIMIT_REACHED: 'PROJECT_LIMIT_REACHED',
  NONE: 'NONE',
  NOT_SUPPORTED: 'NOT_SUPPORTED'
}

export const ACCOUNT_STATUS = {
  SUSPENDED: 'SUSPENDED',
  TRIAL: 'TRIAL',
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  PAST_DUE: 'PAST_DUE',
  DOWNGRADING: 'DOWNGRADING'
}

export const CELLO_SCRIPT_DEV = 'https://assets.sandbox.cello.so/app/latest/cello.js'

export const CELLO_SCRIPT = 'https://assets.cello.so/app/latest/cello.js'

export const CELLO_PRODUCT_ID = 'tiiny.host'

export const CELLO_PRODUCT_ID_DEV = 'stage-tiiny.host'

export const analyticFeatures = [
  { text: 'Unique visitors', icon: '/assets/icons/unique-visitors.svg' },
  { text: 'Views', icon: '/assets/icons/view-eye.svg' },
  { text: 'Traffic sources', icon: '/assets/icons/map-pin.svg' },
  { text: 'Countries', icon: '/assets/icons/globe-europe-africa.svg' },
  { text: 'Visit duration', icon: '/assets/icons/clocks.svg' }
]

export const trackedFeatures = [
  { text: 'Create unique links', icon: '/assets/icons/link-purple.svg' },
  { text: 'Track visitors to each link', icon: '/assets/icons/unique-visitors.svg' },
  { text: 'See who visits your project', icon: '/assets/icons/view-eye.svg' }
]
